import {
  CheckCircle,
  AlertCircle,
  Loader2,
  Clock,
  Activity,
  XCircle,
} from "lucide-react";
import { DEPLOY_STATUS } from "../enums";

export const getDeployStatusColor = (status: string) => {
  switch (status) {
    case DEPLOY_STATUS.COMPLETE:
      return "text-green-400 bg-green-400/10 border-green-400/30";
    case DEPLOY_STATUS.FAILED:
      return "text-red-400 bg-red-400/10 border-red-400/30";
    case DEPLOY_STATUS.IN_PROGRESS:
      return "text-yellow-400 bg-yellow-400/10 border-yellow-400/30";
    case DEPLOY_STATUS.DELETED:
      return "text-gray-400 bg-gray-400/10 border-gray-400/30";
    default:
      return "text-slate-400 bg-slate-400/10 border-slate-400/30";
  }
};

export const getDeployStatusIcon = (status: string) => {
  switch (status) {
    case DEPLOY_STATUS.COMPLETE:
      return <CheckCircle className="w-4 h-4" />;
    case DEPLOY_STATUS.FAILED:
      return <AlertCircle className="w-4 h-4" />;
    case DEPLOY_STATUS.IN_PROGRESS:
      return <Loader2 className="w-4 h-4 animate-spin" />;
    case DEPLOY_STATUS.NEW:
      return <Clock className="w-4 h-4" />;
    case DEPLOY_STATUS.DELETED:
      return <XCircle className="w-4 h-4" />;
    default:
      return <Activity className="w-4 h-4" />;
  }
};
